<script setup lang="ts">
    import { ref, toRef } from 'vue'
    import ContentCollapse from '@/js/components/Common/ContentCollapse.vue'
    import ChartBox from '@/js/components/Chart/ChartBox.vue'
    import { useSemester } from '@/js/composables/useSemester'
    import type { Kennzahl, DashboardValue } from '@/js/composables/chart/types'

    const props = defineProps<{
        dashboardData: DashboardValue[]
        yearsToDisplay: number
    }>()

    const { dashboardDataYears } = useSemester(toRef(props, 'dashboardData'), toRef(props, 'yearsToDisplay'))

    const kennzahlen = ref<Kennzahl[]>([
        {
            kennzahlId: '3.1.',
            kennzahlTitle: 'Anzahl immatrikulierter internationaler Studierender',
            types: ['BarChart', 'LineChart'],
            xAxesLabelString: 'Semester',
            yAxesLabelString: 'Anzahl internationaler Immatrikulierter'
        },
        {
            kennzahlId: '3.2.',
            kennzahlTitle: 'Anzahl internationaler Erst- und Neueinschreiber nach Herkunftsland',
            types: ['BarChart', 'LineChart'],
            dataStrategy: 'aggregatedMap',
            xAxesLabelString: 'Semester',
            yAxesLabelString: 'Anzahl Neueinschreiber',
            showLegend: false
        },
        {
            kennzahlId: '3.3.',
            kennzahlTitle: 'Anzahl auslandsmobiler Studierender - Outgoings',
            types: ['BarChart', 'LineChart'],
            xAxesLabelString: 'Semester',
            yAxesLabelString: 'Anzahl Studierende',
            datasetLabels: ['Immaquote', 'außereuropäisch', 'innereuropäischer']
        },
        {
            kennzahlId: '3.4.',
            kennzahlTitle: 'Anzahl auslandsmobiler Studierender - Incomings',
            types: ['BarChart', 'LineChart'],
            xAxesLabelString: 'Semester',
            yAxesLabelString: 'Anzahl Studierende',
            datasetLabels: ['Immaquote', 'außereuropäisch', 'innereuropäischer']
        }
    ])
</script>

<template>
    <ContentCollapse collapse-key="collapse-dashboard-ziel-3" title="3. Internationalisierung" is-visible-by-default>
        <div class="d-flex flex-wrap p-4 justify-space-between ga-1">
            <ChartBox
                v-for="(kennzahl, key) in kennzahlen"
                :key="kennzahl.kennzahlId"
                :kennzahl="kennzahl"
                :dashboard-data="dashboardData"
                :dashboard-data-years="dashboardDataYears"
                storage-key=""
                :box-size="350"
                :show-title="true"
                :show-target-value="false"
                :center-box="kennzahlen.length === 2 && key === 1"
            />
        </div>
    </ContentCollapse>
</template>

<style scoped></style>
